import React, { useContext, useEffect, useState } from 'react'
import { Box, Input } from '@postenbring/hedwig-react'
import { InternationalCalculatorContext } from '../../InternationalCalculatorContext'

export const PostalCodeInput = ({ postalLabel }) => {
  const {
    serviceType,
    postalNumber,
    setPostalNumber,
    errorInputPostalCode,
    setErrorInputPostalCode,
  } = useContext(InternationalCalculatorContext)

  const [localPostal, setLocalPostal] = useState(postalNumber)

  useEffect(() => {
    setLocalPostal(postalNumber) // Keep in sync if context changes externally
  }, [postalNumber])

  if (!serviceType) return null

  const handleChange = (value) => {
    const sanitized = value
    .replace(/[^a-zA-Z0-9 æøåäöÆØÅÄÖ\-'/]/g, '')
    .slice(0, 15)
  setLocalPostal(sanitized)
  }

  const handleBlur = () => {
    setPostalNumber(localPostal)
  }

  const handleFocus = () => {
    setErrorInputPostalCode(null)
  }

  return (
    <Box style={{ width: '50%', padding: '0px' }}>
      <Input
        errorMessage={errorInputPostalCode}
        autoComplete="off"
        type="text"
        label={postalLabel}
        value={localPostal}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
    </Box>
  )
}
